import type {ReactElement} from 'react';
import React from 'react';
import {ContextualMenuSliderOptions} from '@Components/contextual-menu/components/contextual-menu-slider-options';
import {
  ITEM_MULTIPLY_OPACITY_DISPLAY_MAX,
  ITEM_MULTIPLY_OPACITY_DISPLAY_MIN,
  ITEM_MULTIPLY_OPACITY_MAX,
  ITEM_MULTIPLY_OPACITY_MIN,
} from '@Components/poster-editor/components/poster-editing-side-panel/components/base-item-multiply-option/base-item-multiply-option.types';

interface BaseItemMultiplyOpacityOptionProps {
  multiplyOpacity: number;
  className?: string;
  updateOpacity(value: number, undoable?: boolean): void;
}

export function BaseItemMultiplyOpacityOption({className = '', ...props}: BaseItemMultiplyOpacityOptionProps): ReactElement<any> | null {
  const onChangeOpacity = (updatedValue: number): void => {
    props.updateOpacity(updatedValue, false);
  };

  const onChangeOpacityEnded = (updatedValue: number): void => {
    props.updateOpacity(updatedValue, true);
  };

  return (
    <ContextualMenuSliderOptions
      id="item-multiply-opacity-slider"
      value={props.multiplyOpacity}
      className={className}
      label={window.i18next.t('pmwjs_opacity')}
      range={{min: ITEM_MULTIPLY_OPACITY_MIN, max: ITEM_MULTIPLY_OPACITY_MAX}}
      transformDisplay={{min: ITEM_MULTIPLY_OPACITY_DISPLAY_MIN, max: ITEM_MULTIPLY_OPACITY_DISPLAY_MAX}}
      onChange={onChangeOpacity}
      onChangeEnded={onChangeOpacityEnded}
    />
  );
}
